import * as React from 'react';

const VinCarLogoMark = (props) => {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.3876 13.0004L19.6328 21.4914C18.8802 22.065 18.062 22.5497 17.1958 22.9355L15.3651 18.7999L13.0556 23.9695C12.7654 23.9901 12.4732 24.0005 12.1795 24.0005C11.4163 24.0005 10.6633 23.9301 9.92862 23.7941L15.3876 13.0004ZM12.9874 15.0966L7.55344 23.1013C6.67101 22.7442 5.83429 22.2863 5.06085 21.7375L7.87853 17.9772L2.01342 18.6093C1.88062 18.4109 1.7533 18.2079 1.63175 18.0005C1.22579 17.3077 0.895588 16.585 0.641127 15.8434L12.9874 15.0966ZM14.7452 9.90433L24.2665 10.5232C24.3832 11.4511 24.3896 12.3894 24.2855 13.3183L19.8316 12.8232L23.1292 17.2555C23.0047 17.5072 22.8707 17.7557 22.7273 18.0005C22.3439 18.6547 21.9032 19.2647 21.4136 19.8257L14.7452 9.90433ZM3.13447 3.96383L9.94475 14.0967L0.0898284 13.456C-0.0257528 12.5232 -0.0297962 11.58 0.0776982 10.6465L4.85837 11.1778L1.36442 6.48169C1.44954 6.3198 1.53865 6.15936 1.63175 6.00049C2.06383 5.26312 2.5687 4.58199 3.13447 3.96383ZM12.1795 0.000488281C13.0473 0.000488281 13.9019 0.0914466 14.7313 0.26653L9.30238 11.0005L4.96756 2.33035C5.73419 1.77547 6.56453 1.31063 7.44112 0.945766L9.32483 5.20111L11.6431 0.0120939C11.8213 0.00437696 12.0001 0.000488281 12.1795 0.000488281ZM19.5125 2.41905L16.8114 6.02382L22.3679 5.42505C22.4927 5.61281 22.6126 5.80467 22.7273 6.00049C23.1369 6.69938 23.4693 7.42881 23.7247 8.17727L11.7026 8.90438L17.0633 1.00737C17.9324 1.38231 18.7546 1.85615 19.5125 2.41905Z"
        fill="url(#paint0_linear_303_36265)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_303_36265"
          x1="16.6948"
          y1="7.42737"
          x2="4.39652"
          y2="19.9794"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D600F1" />
          <stop offset="1" stopColor="#8800FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default VinCarLogoMark;
